import * as React from "react";
import AuthorSlider, { AuthorSliderProps } from "~/components/author-slider/author-slider";

export interface AuthorSliderViewProps {
    contextModel: AuthorSliderProps;
}

class AuthorSliderView extends React.PureComponent<AuthorSliderViewProps> {
    public render() {
        return <AuthorSlider {...this.props.contextModel} />;
    }
}

export default AuthorSliderView;
